import {
  requiredString,
  email,
  firstName,
  lastName,
  password,
  confirmPassword,
  playlistName,
  playlistDisplay,
  playlistLabels,
  defaultSlideDuration,
  displayGroupName,
  resolution,
  defaultPlaylist,
  requiredMessage,
  phoneNumber
} from 'src/helpers/schema'
import { US_STATE_VALUES } from 'src/constants/us-states'
import {
  CA_PROVINCE_VALUES,
  SUPPORTED_COUNTRY_VALUES
} from 'src/constants/regions'
import * as yup from 'yup'

export const signInSchema = yup.object().shape({
  email,
  password: requiredString()
})

export const signUpSchema = yup.object().shape({
  email,
  password,
  firstName,
  lastName,
  terms: yup.boolean().oneOf([true], 'checkbox must be checked')
})

export const signUpProviderSchema = signUpSchema.shape({
  phoneNumber,
  companyName: yup.string()
    .ensure()
    .required(requiredMessage),
  password: yup
    .string()
    .matches(/^[a-zA-Z0-9!@#$&()\\-`.+,/\"]*$/, 'can only contain numbers, letters and symbols')
    .min(8, 'must be at least 8 characters')
    .max(30, 'must be at most 30 characters'),
  addressLine1: yup.string().ensure().required(requiredMessage),
  addressLine2: yup.string(),
  city: yup.string().ensure().required(requiredMessage),
  country: yup
    .string()
    .ensure()
    .required(requiredMessage)
    .oneOf(SUPPORTED_COUNTRY_VALUES as string[], 'Select a valid country'),
  state: yup
    .string()
    .ensure()
    .required(requiredMessage)
    .when('country', {
      is: 'CA',
      then: yup
        .string()
        .oneOf(CA_PROVINCE_VALUES as string[], 'Select a valid province'),
      otherwise: yup
        .string()
        .oneOf(US_STATE_VALUES as string[], 'Select a valid US state')
    }),
  zipCode: yup.string().ensure().required(requiredMessage)
})

export const forgotPasswordSchema = yup.object().shape({
  email
})

export const resetPasswordSchema = yup.object().shape({
  password,
  confirmPassword
})

export const passwordInSchema = yup.object().shape({
  password: requiredString()
})

export const pinInSchema = yup.object().shape({
  pin: requiredString()
})

export const newPlaylistSchema = yup.object().shape({
  playlistName,
  playlistDisplay,
  playlistLabels,
  defaultSlideDuration
})

export const newDisplayGroupSchema = yup.object().shape({
  displayGroupName,
  resolution,
  defaultPlaylist
})
